/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box } from '@sonyged/proc-ui';
import { css } from '@styled-system/css';

import { Tab } from './Tab';
import { TabBar, TabBarItem } from './TabBar';

type Props = {
  children: React.ChildrenArray<React.Element<typeof Tab>>,
  defaultTabIndex?: number,
};

export function Tabs(props: Props) {
  let { children, defaultTabIndex = 0, ...rest } = props;

  let [activeTabIndex, setActiveTabIndex] = React.useState(defaultTabIndex);

  return (
    <TabsContainer {...rest}>
      <TabBar className="proc-tabbar">
        {React.Children.map(children, (child, i) => (
          <TabBarItem active={i === activeTabIndex} title={child.props.title} onClick={() => setActiveTabIndex(i)} />
        ))}
      </TabBar>

      <TabContentContainer className="proc-tabcontent">
        {React.Children.map(children, (child, i) => (
          <TabContent active={i === activeTabIndex}>{child.props.children}</TabContent>
        ))}
      </TabContentContainer>
    </TabsContainer>
  );
}

const TabsContainer = styled(Box)(
  css({
    display: 'flex',
    flexDirection: 'column',
  })
);

const TabContentContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  minHeight: 0,
});
const TabContent = styled(Box)(
  {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    minHeight: 0,
  },
  ({ active }) => !active && css({ display: 'none' })
);
